'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _ComponentWithPartials = require('../mixins/ComponentWithPartials');

var _ComponentWithPartials2 = _interopRequireDefault(_ComponentWithPartials);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UIButton = require('../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var I18N_PREFIX = 'salesUI.UIPaginator';

var UIPaginator = _react2.default.createClass({
  displayName: 'UIPaginator',

  mixins: [_ComponentWithPartials2.default, _reactAddonsPureRenderMixin2.default],

  propTypes: {
    className: _react2.default.PropTypes.string,
    disabledPageTooltipTitle: _react2.default.PropTypes.node,
    maxVisiblePageButtons: _react2.default.PropTypes.number,
    onPageChange: _react2.default.PropTypes.func.isRequired,
    page: _react2.default.PropTypes.number.isRequired,
    pageCount: _react2.default.PropTypes.number.isRequired,
    enabledPageLimit: _react2.default.PropTypes.number,
    showFirstLastButtons: _react2.default.PropTypes.bool.isRequired,
    showButtonLabels: _react2.default.PropTypes.bool.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      maxVisiblePageButtons: 11,
      showFirstLastButtons: false,
      showButtonLabels: true
    };
  },
  getMinAndMaxPageNumbers: function getMinAndMaxPageNumbers(maxVisiblePageButtons, page, pageCount) {
    var buffer = (maxVisiblePageButtons - 1) / 2;

    var min = page - buffer;
    var max = page + buffer;
    var numPagesToShow = Math.min(maxVisiblePageButtons, pageCount);

    if (min < 1) {
      min = 1;
      max = min + maxVisiblePageButtons - 1;
    }
    if (max > pageCount) {
      max = Math.max(pageCount, 1);
      min = max - numPagesToShow + 1;
    }

    return [Math.floor(min), Math.floor(max)];
  },
  goToPage: function goToPage(page) {
    if (page === this.props.page) return;
    this.props.onPageChange((0, _SyntheticEvent2.default)(page));
  },
  renderNumberedPages: function renderNumberedPages(maxVisiblePageButtons, page, pageCount, enabledPageLimit, disabledPageTooltipTitle) {
    var _getMinAndMaxPageNumb = this.getMinAndMaxPageNumbers(maxVisiblePageButtons, page, pageCount),
        _getMinAndMaxPageNumb2 = _slicedToArray(_getMinAndMaxPageNumb, 2),
        min = _getMinAndMaxPageNumb2[0],
        max = _getMinAndMaxPageNumb2[1];

    var links = [];

    for (var currentPage = min; currentPage <= max; currentPage++) {
      var isActive = currentPage === page;
      links.push(_react2.default.createElement(
        _UITooltip2.default,
        {
          disabled: enabledPageLimit == null || enabledPageLimit != null && currentPage <= enabledPageLimit,
          title: disabledPageTooltipTitle,
          key: currentPage - min
        },
        _react2.default.createElement(
          _UIButton2.default,
          {
            active: isActive,
            'aria-current': isActive ? 'true' : null,
            className: (0, _classNames2.default)('private-paginator__button', 'private-paginator__button--numeric', { 'private-paginator__button--active': isActive }),
            'data-page-number': currentPage,
            disabled: enabledPageLimit != null && currentPage > enabledPageLimit,
            key: currentPage - min,
            onClick: this.partial(this.goToPage, currentPage),
            responsive: false,
            size: 'extra-small',
            use: 'transparent'
          },
          _react2.default.createElement(
            'span',
            { className: 'sr-only' },
            isActive ? _I18n2.default.text(I18N_PREFIX + '.pageNumber.currentIndicator') : null,
            _I18n2.default.text(I18N_PREFIX + '.pageNumber.description')
          ),
          currentPage
        )
      ));
    }

    return links;
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        disabledPageTooltipTitle = _props.disabledPageTooltipTitle,
        enabledPageLimit = _props.enabledPageLimit,
        maxVisiblePageButtons = _props.maxVisiblePageButtons,
        __onPageChange = _props.onPageChange,
        page = _props.page,
        pageCount = _props.pageCount,
        showFirstLastButtons = _props.showFirstLastButtons,
        showButtonLabels = _props.showButtonLabels,
        rest = _objectWithoutProperties(_props, ['className', 'disabledPageTooltipTitle', 'enabledPageLimit', 'maxVisiblePageButtons', 'onPageChange', 'page', 'pageCount', 'showFirstLastButtons', 'showButtonLabels']);

    if (page > pageCount) {
      _devLogger2.default.warn({
        message: 'UIPaginator: page must not exceed pageCount: page={' + page + '} pageCount={' + pageCount + '}',
        key: 'UIPaginator: bad page value'
      });
    }

    var arrowButtonClassName = showButtonLabels ? '' : 'sr-only';

    return _react2.default.createElement(
      'nav',
      _extends({
        'aria-label': _I18n2.default.text(I18N_PREFIX + '.label'),
        className: (0, _classNames2.default)('private-paginator', className),
        'data-current-page': page,
        role: 'navigation'
      }, rest),
      _react2.default.createElement(
        'span',
        { className: 'private-paginator__backward-controls' },
        showFirstLastButtons ? _react2.default.createElement(
          _UIButton2.default,
          {
            'aria-label': _I18n2.default.text(I18N_PREFIX + '.firstPage.description'),
            className: 'private-paginator__button',
            'data-first-page': true,
            disabled: page < 2,
            key: 'first',
            onClick: this.partial(this.goToPage, 1),
            responsive: false,
            size: 'extra-small',
            use: 'transparent'
          },
          _react2.default.createElement(_UIIcon2.default, { className: 'private-paginator__icon', name: 'first' }),
          _react2.default.createElement(
            'span',
            { className: arrowButtonClassName },
            _I18n2.default.text(I18N_PREFIX + '.firstPage.label')
          )
        ) : null,
        _react2.default.createElement(
          _UIButton2.default,
          {
            'aria-label': _I18n2.default.text(I18N_PREFIX + '.previousPage.description'),
            className: 'private-paginator__button',
            'data-prev-page': true,
            disabled: page < 2,
            key: 'prev',
            onClick: this.partial(this.goToPage, Math.max(page - 1, 1)),
            responsive: false,
            size: 'extra-small',
            use: 'transparent'
          },
          _react2.default.createElement(_UIIcon2.default, { className: 'private-paginator__icon', name: 'left', size: 'xs' }),
          _react2.default.createElement(
            'span',
            { className: arrowButtonClassName },
            _I18n2.default.text(I18N_PREFIX + '.previousPage.label')
          )
        )
      ),
      _react2.default.createElement(
        'span',
        { className: 'private-paginator__numbers' },
        this.renderNumberedPages(maxVisiblePageButtons, page, pageCount, enabledPageLimit, disabledPageTooltipTitle)
      ),
      _react2.default.createElement(
        'span',
        { className: 'private-paginator__forward-controls' },
        _react2.default.createElement(
          _UIButton2.default,
          {
            'aria-label': _I18n2.default.text(I18N_PREFIX + '.nextPage.description'),
            className: 'private-paginator__button',
            'data-next-page': true,
            disabled: page >= pageCount || enabledPageLimit != null && page >= enabledPageLimit,
            key: 'next',
            onClick: this.partial(this.goToPage, Math.min(page + 1, pageCount)),
            responsive: false,
            size: 'extra-small',
            use: 'transparent'
          },
          _react2.default.createElement(
            'span',
            { className: arrowButtonClassName },
            _I18n2.default.text(I18N_PREFIX + '.nextPage.label')
          ),
          _react2.default.createElement(_UIIcon2.default, {
            className: 'private-paginator__icon',
            name: 'right',
            size: 'xs'
          })
        ),
        showFirstLastButtons ? _react2.default.createElement(
          _UIButton2.default,
          {
            'aria-label': _I18n2.default.text(I18N_PREFIX + '.lastPage.description'),
            className: 'private-paginator__button',
            'data-last-page': true,
            disabled: enabledPageLimit != null ? page >= enabledPageLimit : pageCount === page,
            key: 'last',
            onClick: this.partial(this.goToPage, enabledPageLimit != null ? enabledPageLimit : pageCount),
            responsive: false,
            size: 'extra-small',
            use: 'transparent'
          },
          _react2.default.createElement(
            'span',
            { className: arrowButtonClassName },
            _I18n2.default.text(I18N_PREFIX + '.lastPage.label')
          ),
          _react2.default.createElement(_UIIcon2.default, { className: 'private-paginator__icon', name: 'last' })
        ) : null
      )
    );
  }
});

exports.default = UIPaginator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/paginator/UIPaginator.js
// module id = 589
// module chunks = 171